export default {
  添加群组: '添加群组',
  编辑群组: '编辑群组',
  删除群组: '删除群组',
  我的客户库: '我的客户库',
  客户库: '客户库',
  客户库群组: '客户库群组',
  传真: '传真',
  座机号: '座机号',
  所属群组: '所属群组',
  正在提交数据提示: '正在提交数据,请稍等。',
  个客户: '个客户',
  已选择: '已选择',
  通讯录群组提示4: '群组描述不能超过120个字符！',
  通讯录群组提示3: '群组描述不能为空!',
  通讯录群组提示2: '群组名称不能超过10个字符！',
  通讯录群组提示1: '群组名称不能为空!',
  修改成功: '修改成功',
  角色类型选填: '角色类型(选填)！',
  通讯录自主添加提示13: '企业名称不能超过120个字符！',
  通讯录自主添加提示12: '岗位不能超过30个字符！',
  通讯录自主添加提示11: '邮箱格式错误！',
  通讯录自主添加提示10: '邮箱不能超过60个字符！',
  通讯录自主添加提示9: '手机号不能为空!',
  通讯录自主添加提示8: '微信号不能超过30个字符！',
  微信号: '微信号',
  通讯录自主添加提示7: '固话号码不能超过30个字符！',
  通讯录自主添加提示6: '固话格式错误！',
  通讯录自主添加提示5: '手机号格式错误!',
  通讯录自主添加提示4: '手机号不能超过15个字符!',
  通讯录自主添加提示3: '手机号不能为空!',
  通讯录自主添加提示2: '客户姓名不能超过30个字符！',
  通讯录自主添加提示1: '客户姓名不能为空!',
  通讯录大数据库: '通讯录大数据库',
  通讯录客户自增: '通讯录客户自增',
  通讯录客户名片: '通讯录客户云展',
  拍照识别: '拍照识别',
  添加客户: '添加客户',
  删除成功: '删除成功',
  群组客户人数: '群组客户人数',
  群组描述: '群组描述',
  群组名称: '群组名称',
  群组ID: '群组ID',
  是否付费客户: '是否付费客户',
  确定要删除吗: '确定要删除吗?',
  从云数据新增: '从云数据新增',
  自主新增客户: '自主新增客户',
  请输入: '请输入',
  角色类型: '角色类型',
  客户类型: '客户类型',
  新增群组: '新增群组',
  通讯录提示1: '没有客户？来试试大数据获客，4.12亿全球企业客户等你来挖掘>',
  客户管理: '客户管理',
  群组管理: '群组管理',
}
